module.exports = __webpack_public_path__ + "img/forgot-password.82c357e3.jpeg";